import classNames from "classnames";
import pcComachi from "images/introduction/PC.png";
import support from "images/introduction/support.png";
import apps from "images/introduction/apps.png";
import iconComachi from "images/logo.png";
import React from "react";
import Style from "styles/components/introduction.module.scss";

const Introduction01 = () => {
  return (
    <>
      <div className={classNames(Style.function__boxWrapper)}>
          <div className={classNames(Style.function__funcContainer1)}>
            <div className={classNames(Style.function__funcContainer1__imgContainer)}>
              <img className={Style.function__funcContainer1__img} src={pcComachi} alt="Comachi PC"/>
            </div>
          <div className={classNames(Style.function__funcContainer1__textWrapper)}>
            <div className={classNames(Style.function__funcContainer1__textWrapper__index)}>
              01
            </div>
            <div className={classNames(Style.function__funcContainer1__textWrapper__content)}>
              売れるまでずっと無料。<br />
              気軽にネット販売を始められる
            </div>
            <div className={classNames(Style.function__funcContainer1__textWrapper__notes)}>
              <ul>
                <li>初期費用・月額料金を0円でスタート</li>
                <li>手数料は売れた分だけ</li>
              </ul>
            </div>
          </div>
          </div>
      </div>
    </>
  );
}

const Introduction02 = () => {
  return (
    <>
      <div className={classNames(Style.function__boxWrapper)}>
          <div className={classNames(Style.function__funcContainer2)}>
            <div className={classNames(Style.function__funcContainer2__textWrapper)}>
              <div className={classNames(Style.function__funcContainer2__textWrapper__index)}>
              02
              </div>
              <div className={classNames(Style.function__funcContainer2__textWrapper__content)}>
              基本機能はしっかり使える<br />
              必要な機能はあとから追加
              </div>
              <div className={classNames(Style.function__funcContainer2__textWrapper__notes)}>
                <ul>
                  <li>運営に必要な販促機能は標準搭載</li>
                  <li>アプリ機能を使って運営の幅を広げる</li>
                </ul>
              </div>
            </div>
            <div className={classNames(Style.function__funcContainer2__imgContainer)}>
              <img className={Style.function__funcContainer2__img} src={apps} alt="Comachi アプリ機能"/>
            </div>
          </div>
       </div>
    </>
  );
}

const Introduction03 = () => {
  return (
    <>
      <div className={classNames(Style.function__boxWrapper)}>
          <div className={classNames(Style.function__funcContainer3)}>
            <div className={classNames(Style.function__funcContainer3__imgContainer)}>
              <img className={Style.function__funcContainer3__img} src={support} alt="Comachi サポート"/>
            </div>
            <div className={classNames(Style.function__funcContainer3__textWrapper)}>
              <div className={classNames(Style.function__funcContainer3__textWrapper__index)}>
              03
              </div>
              <div className={classNames(Style.function__funcContainer3__textWrapper__content)}>
              一人で運営が出来るように<br />
              検討時から同じ担当者がサポート
              </div>
              <div className={classNames(Style.function__funcContainer3__textWrapper__notes)}>
                <ul>
                   <li>検討時に運用の相談をしながらサイト制作の体験ができる</li>
                  <li>分からなくなったら、専任担当者にメール/電話/打合せで相談</li>
                  <li>運用に慣れたら、学習講座でECに関する知識を学べる</li>
                </ul>
              </div>
             </div>
          </div>
       </div>
    </>
  );
}

const Introduction = () => {
  return (
    <>
        <section className={Style.introduction}>
            <div className={classNames(Style.introduction__catch)}>
                ネットショップを始めるには<br />
                専門知識を自分で調べて学ぶ必要があり、想像以上に大変です<br />
            </div>
            <div className={classNames(Style.introduction__comachicart)}>
                でも、
                <span className={classNames(Style.introduction__comachicart__hasBlueText)}>
                comachicartなら大丈夫。<br />
                </span>
            </div>
            <div className={classNames(Style.introduction__triangleWrapper)}>
                <div className={classNames(Style.introduction__triangle, Style.introduction__triangle__1)}></div>
                <div className={classNames(Style.introduction__triangle, Style.introduction__triangle__2)}></div>
            </div>
        </section>
        <section className={Style.function}>
            <div className={classNames(Style.function__imgContainer)}>
              <img className={Style.function__logoComachi} src={iconComachi} alt="Comachi アプリ機能"/>
            </div>
            <h2 className={classNames(Style.function__title)}>
                comachicartの特徴
            </h2>
          <Introduction01 />
          <Introduction02 />
          <Introduction03 />
        </section>
    </>
  );
};
export default Introduction;
